import { format, isValid, parseISO } from 'date-fns';

export const getCurrentTimeString = function() {
	return getTimeString(new Date());
};

export const getTimeString = function(dateTime) {
	return formatTime(dateTime, 12);
};

export const getTimeOnlyString = function(time) {
	return getTimeString(getDateTime(null, time));
};

export const getTimeStringUTC = function(dateTime) {
	return formatTimeUTC(dateTime, 12);
};

export const getCurrent24HourTimeString = function() {
	const date = new Date();
	return formatTime(date, 24);
};

export const get24HourTimeString = function(dateTime) {
	return formatTime(dateTime, 24);
};

export const formatTime = function(dateTime, format) {
	const date = new Date(dateTime);

	const options = {
		hour: 'numeric',
		minute: 'numeric',
		hour12: format === 12 ? true : false
	};

	const timeString = date.toLocaleTimeString('en-us', options);

	if (format === 12) return timeString.replace(/(\d+:\d+)\s(.*)/, '$1 $2');

	return timeString;
};

export const formatTimeUTC = function(dateTime, format) {
	const date = new Date(dateTime + 'Z');
	const options = {
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
		hour12: format === 12 ? true : false
	};

	const timeString = date.toLocaleTimeString('en-us', options);

	if (format === 12) return timeString.replace(/(\d+:\d+)\s(.*)/, '$1 $2');

	return timeString;
};

export const getYear = function() {
	const today = new Date();
	const year = today.getFullYear();

	return year;
};

/*
	Forces UTC or passes it through
	(especially if not a string type)
*/
export const dateTimeString = function(jsondate) {	
	let utc;
	// Expects UTC (unformatted) from JSON payload...
	if (typeof jsondate === 'string') {
		// Always treat as UTC: append 'Z' if not present
		utc = new Date(jsondate.endsWith('Z') ? jsondate : jsondate + 'Z');
	} else if (jsondate instanceof Date) {
		// Interpret the Date as local and convert to UTC by using its components as UTC
		utc = new Date(Date.UTC(
			jsondate.getFullYear(),
			jsondate.getMonth(),
			jsondate.getDate(),
			jsondate.getHours(),
			jsondate.getMinutes(),
			jsondate.getSeconds(),
			jsondate.getMilliseconds()
		));
	} else {
		const str = String(jsondate);
		utc = new Date(str.endsWith('Z') ? str : str + 'Z');
	}
	return localeString(utc, 'en-us');
};

export const dateString = function(jsondate) {
	//Expects UTC (unformatted) from JSON payload...
	/*if (typeof jsondate === 'string') {
		//forces UTC or passes it through
		//(especially if not a string type)
		jsondate += jsondate.includes('Z') ? '' : 'Z';
	}*/
	const utc = new Date(jsondate + 'Z');
	return shortlocaleString(utc, 'en-us');
};

export const simulateIsoDate = function(jsdate) {
	var isoDate = jsdate.toISOString(); //(ISO-8601)...
	return new Date(isoDate.slice(0, -1));
	//^ simulates db-server UTC by removing 'Z' in cache/store...
};

export const localeString = function(utcdate, locale) {
	const d = new Date(utcdate);
	let dt = d.toLocaleDateString(locale);
	let tm = d.toLocaleTimeString(locale);
	return `${dt} ${tm}`;
};

export const shortlocaleString = function(utcdate, locale) {
	const d = new Date(utcdate);
	let dt = d.toLocaleDateString(locale);
	return `${dt}`;
};

export const formatShortDate = date => {
	let result;

	result = format(new Date(date), 'M/d/yyyy');

	return result;
};

export const formatShortDateTime = dateTime => {
	let result;

	result = format(new Date(dateTime), 'M/d/yyyy h:mm bbb');

	return result;
};

export const formatDate = (date, dateFormat) => {
	let result;

	result = format(new Date(date), dateFormat);

	return result;
};

export const formatLocalDate = (date, dateFormat) => {
	let result;
	const slicedDate = date.slice(0, 19);
	const localDate = new Date(slicedDate + '.000Z');
	result = format(localDate, dateFormat);

	return result;
};

export const timeZoneShort = (dateTime = null) => {
	let timeZone = new Date(dateTime)
		.toLocaleDateString(undefined, {
			day: '2-digit',
			timeZoneName: 'short'
		})
		.substring(4);
	return timeZone;
};

export const formatDateTimeZoneShort = (dateTime, format = 'M/d/yyyy') => {
	return (
		dateTime &&
		`${formatDate(dateTime, format)} ${getTimeString(
			dateTime
		)} ${timeZoneShort(dateTime)}`
	);
};

export const formatDateTimeZoneLarge = dateTime => {
	const dateObject = parseISO(dateTime);

	const formattedDateTime = format(dateObject, 'MM/dd/yyyy hh:mm aaa');
	return formattedDateTime;
};

export const formatISODate = value => {
	if (!value) return undefined;
	let formattedDate;
	const date = new Date(value);
	if (isValid(date)) {
		formattedDate = date.toISOString();
	}

	return formattedDate;
};

/*Get a specific Date with Time passed as a parameter
     date: Date time if null it gets now
	 time: is string "Hour:Min:Sec"
}*/
export const getDateTime = (date = null, time = '12:00:00') => {
	// Format string "Hour:Min:Sec"
	date = date || new Date();
	date.setHours(0, 0, 0, 0);
	var timearray = time?.split(':');
	if (timearray && timearray.length > 0) {
		date.setHours(timearray[0] ?? 0); // Hours
		date.setMinutes(timearray[1] ?? 0); // Minutes
		date.setSeconds(timearray[2] ?? 0); // Seconds
	}
	return date;
};

export const getTimeFromISO12Hour = isoDateString => {
	const date = new Date(isoDateString);
	return date.toLocaleTimeString([], {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true
	});
};
